import { ApiService } from './ApiService';

let isFetching = false;
let lastFetchedFarmId: string | null = null;

export async function loadAndStoreFarmMetadata(farmId: string, token: string): Promise<void> {
  if (isFetching) {
    return;
  }

  // Skip if we already fetched for this farmId and data is still in localStorage
  if (lastFetchedFarmId === farmId && window.localStorage.getItem('farmName')) {
    return;
  }

  isFetching = true;

  try {
    // Temporarily set token in localStorage so API calls work
    const oldToken = window.localStorage.getItem('token');
    window.localStorage.setItem('token', token);

    const apiService = new ApiService();
    const result = await apiService.api.farms.farmsGetCurrentUserFarm();
    const farm = result.data;

    window.localStorage.setItem('farmMetadata', JSON.stringify(farm.metadata || { weightUnit: 1 }));

    let tzId = farm.timezoneId ?? '';
    if (!tzId) {
      try {
        const settingsResult = await apiService.api.settings.settingsGetFarmSettings({});
        tzId = settingsResult.data.timeZoneId ?? '';
      } catch {}
    }
    window.localStorage.setItem('farmTimeZoneId', tzId);

    if (farm.name) {
      window.localStorage.setItem('farmName', farm.name);
    }

    lastFetchedFarmId = farmId;

    if (oldToken && oldToken !== token) {
      window.localStorage.setItem('token', oldToken);
    }
  } catch (e) {
    console.error('Failed to load farm metadata:', e);
    window.localStorage.setItem('farmMetadata', JSON.stringify({ weightUnit: 1 }));
  } finally {
    isFetching = false;
  }
}
